<span class="available-from-filter">
  <span class="available-from-filter__label">{{ 'benchOverview.availability.dateLabel' | translate }}</span>
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="available-from-filter__field">
    <input matInput
           #dateInput
           [matDatepicker]="availableFromPicker"
           [formControl]="control"
           [placeholder]="'benchOverview.availability.datePlaceholder' | translate"
           [attr.aria-label]="'benchOverview.availability.dateAriaLabel' | translate"
           [matTooltip]="'benchOverview.availability.dateTooltip' | translate"
           [aria-describedby]="value ? hintId : ''"
           (input)="onInput(dateInput.value)"
           (dateChange)="onDateChange($event)" />
    @if (hasText()) {
      <button mat-icon-button matIconSuffix type="button"
              class="available-from-filter__clear"
              [attr.aria-label]="'benchOverview.availability.dateClear' | translate"
              (click)="onClearClick()">
        <mat-icon fontIcon="close"></mat-icon>
      </button>
    }
    <mat-datepicker-toggle matIconSuffix [for]="availableFromPicker"></mat-datepicker-toggle>
    <mat-datepicker #availableFromPicker>
      <mat-datepicker-actions>
        <button mat-button matDatepickerCancel>{{ 'general.cancel' | translate }}</button>
        <button mat-flat-button matDatepickerApply>{{ 'general.apply' | translate }}</button>
      </mat-datepicker-actions>
    </mat-datepicker>
    <mat-error>{{ 'benchOverview.availability.dateInvalid' | translate }}</mat-error>
  </mat-form-field>
  @if (value) {
    @let hintText = 'benchOverview.availability.dateHint' | translate: {date: hintDate};
    <mat-icon class="available-from-filter__info"
              fontIcon="info"
              tabindex="0"
              role="img"
              aria-hidden="false"
              [attr.aria-label]="hintText"
              [matTooltip]="hintText"></mat-icon>
    <span class="available-from-filter__sr-hint cdk-visually-hidden" [id]="hintId">{{ hintText }}</span>
  }
</span>
